module.exports = __webpack_public_path__ + "img/undraw_Taken_if77.20521f12.svg";